import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import DatePickerField from "../../Components/Common/DatePickerField";

const VehicleSchema = Yup.object().shape({
  // vehicleName: Yup.string().required("Vehicle name is required"),
  vehicleNo: Yup.string().required("Vehicle number is required"),
  // vehicleModelNo: Yup.string().required("Model number is required"),
  kmRate: Yup.number()
    .positive("Must be positive")
    .required("KM rate required"),
  localRate: Yup.number()
    .positive("Must be positive")
    .required("Local rate required"),
  vehicleCapacity: Yup.string().required("Capacity is required"),
  // capacityUnit: Yup.string().required("Capacity unit is required"),
  //   insuranceStartDate: Yup.date().required("Insurance start date required"),
  //   insuranceEndDate: Yup.date().required("Insurance end date required"),
  //   roadTaxStartDate: Yup.date().required("Road tax start date required"),
  //   roadTaxEndDate: Yup.date().required("Road tax end date required"),
  //   pucStartDate: Yup.date().required("PUC start date required"),
  //   pucEndDate: Yup.date().required("PUC end date required"),
});

const AddVehicleModal = ({ show, toggle, onSubmit }) => {
  const initialValues = {
    vehicleName: "",
    vehicleNo: "",
    vehicleModelNo: "",
    kmRate: "",
    localRate: "",
    vehicleCapacity: "",
    capacityUnit: "",
    insuranceStartDate: "",
    insuranceEndDate: "",
    roadTaxStartDate: "",
    roadTaxEndDate: "",
    pucStartDate: "",
    pucEndDate: "",
  };

  const preventNumberChange = (e) => {
    if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  const preventWheelChange = (e) => {
    e.currentTarget.blur();
  };

  return (
    <Modal isOpen={show} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Add Vehicle</ModalHeader>
      <Formik
        initialValues={initialValues}
        validationSchema={VehicleSchema}
        // onSubmit={(values, { resetForm }) => {
        //   if (onSubmit) onSubmit(values);
        //   resetForm();
        //   toggle();
        // }}

        onSubmit={(values, { resetForm }) => {
          // Remove empty fields
          const cleanedValues = Object.fromEntries(
            Object.entries(values).filter(([key, value]) => {
              if (value === "" || value === null || value === undefined)
                return false;
              if (Array.isArray(value) && value.length === 0) return false;
              if (
                typeof value === "object" &&
                !Array.isArray(value) &&
                Object.keys(value).length === 0
              )
                return false;
              return true;
            }),
          );

          if (onSubmit) onSubmit(cleanedValues);

          resetForm();
          toggle();
        }}
      >
        {({ errors, touched }) => (
          <Form>
            <ModalBody>
              <Row className="gy-3 mb-3">
                <Col md={6}>
                  <Label>Vehicle Name</Label>
                  <Field
                    name="vehicleName"
                    as={Input}
                    invalid={touched.vehicleName && !!errors.vehicleName}
                  />
                  <ErrorMessage name="vehicleName" component={FormFeedback} />
                </Col>

                <Col md={6}>
                  <Label>
                    Vehicle Number <span className="text-danger">*</span>
                  </Label>
                  <Field
                    name="vehicleNo"
                    as={Input}
                    invalid={touched.vehicleNo && !!errors.vehicleNo}
                  />
                  <ErrorMessage name="vehicleNo" component={FormFeedback} />
                </Col>

                <Col md={6}>
                  <Label>Model Number</Label>
                  <Field
                    name="vehicleModelNo"
                    as={Input}
                    invalid={touched.vehicleModelNo && !!errors.vehicleModelNo}
                  />
                  <ErrorMessage
                    name="vehicleModelNo"
                    component={FormFeedback}
                  />
                </Col>

                <Col md={6}>
                  <Label>
                    Vehicle Capacity <span className="text-danger">*</span>
                  </Label>
                  <Field
                    name="vehicleCapacity"
                    as={Input}
                    invalid={
                      touched.vehicleCapacity && !!errors.vehicleCapacity
                    }
                  />
                  <ErrorMessage
                    name="vehicleCapacity"
                    component={FormFeedback}
                  />
                </Col>

                <Col md={6}>
                  <Label>Capacity Unit</Label>
                  <Field
                    name="capacityUnit"
                    as={Input}
                    invalid={touched.capacityUnit && !!errors.capacityUnit}
                  />
                  <ErrorMessage name="capacityUnit" component={FormFeedback} />
                </Col>

                <Col md={6}>
                  <Label>
                    KM Rate <span className="text-danger">*</span>
                  </Label>
                  <Field
                    name="kmRate"
                    type="number"
                    as={Input}
                    invalid={touched.kmRate && !!errors.kmRate}
                    onKeyDown={preventNumberChange}
                    onWheel={preventWheelChange}
                  />
                  <ErrorMessage name="kmRate" component={FormFeedback} />
                </Col>

                <Col md={6}>
                  <Label>
                    Local Rate <span className="text-danger">*</span>
                  </Label>
                  <Field
                    name="localRate"
                    type="number"
                    as={Input}
                    invalid={touched.localRate && !!errors.localRate}
                    onKeyDown={preventNumberChange}
                    onWheel={preventWheelChange}
                  />
                  <ErrorMessage name="localRate" component={FormFeedback} />
                </Col>
              </Row>

              {/* Dates */}
              {/* <Col md={6}>
                  <Label>Insurance Start Date</Label>
                  <Field name="insuranceStartDate" type="date" as={Input} />
                </Col>
                <Col md={6}>
                  <Label>Insurance End Date</Label>
                  <Field name="insuranceEndDate" type="date" as={Input} />
                </Col>

                <Col md={6}>
                  <Label>Road Tax Start Date</Label>
                  <Field name="roadTaxStartDate" type="date" as={Input} />
                </Col>
                <Col md={6}>
                  <Label>Road Tax End Date</Label>
                  <Field name="roadTaxEndDate" type="date" as={Input} />
                </Col>

                <Col md={6}>
                  <Label>PUC Start Date</Label>
                  <Field name="pucStartDate" type="date" as={Input} />
                </Col>
                <Col md={6}>
                  <Label>PUC End Date</Label>
                  <Field name="pucEndDate" type="date" as={Input} />
                </Col> */}

              <Row className="gy-3">
                <Col md={6}>
                  <Label>Insurance Start Date</Label>
                  <div className="input-group">
                    <DatePickerField name="insuranceStartDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>

                <Col md={6}>
                  <Label>Insurance End Date</Label>
                  <div className="input-group">
                    <DatePickerField name="insuranceEndDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>

                <Col md={6}>
                  <Label>Road Tax Start Date</Label>
                  <div className="input-group">
                    <DatePickerField name="roadTaxStartDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>

                <Col md={6}>
                  <Label>Road Tax End Date</Label>
                  <div className="input-group">
                    <DatePickerField name="roadTaxEndDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>

                <Col md={6}>
                  <Label>PUC Start Date</Label>
                  <div className="input-group">
                    <DatePickerField name="pucStartDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>

                <Col md={6}>
                  <Label>PUC End Date</Label>
                  <div className="input-group">
                    <DatePickerField name="pucEndDate" />
                    <span className="input-group-text">
                      <i className="ri-calendar-2-line"></i>
                    </span>
                  </div>
                </Col>
              </Row>
            </ModalBody>

            <ModalFooter>
              <Button color="secondary" className="btn-sm" onClick={toggle}>
                Cancel
              </Button>
              <Button color="success" className="btn-sm" type="submit">
                Save Vehicle
              </Button>
            </ModalFooter>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddVehicleModal;
